import { FeatureFlagsEnum } from '../enums/feature-flags.enum';

// TODO: This could be replaced by and API call to the back end
export const featureFlags: Record<FeatureFlagsEnum, boolean> = {
  [FeatureFlagsEnum.VIEW_SECTION_BREADCRUMBS]: true,
  [FeatureFlagsEnum.FEATURE_INERTIA_INPUTS]: false,
  [FeatureFlagsEnum.FEATURE_INVERTER_LOSS_MAP]: true,
  [FeatureFlagsEnum.FEATURE_THERMAL_MODEL]: true,
};
